import { Link, useParams } from 'react-router-dom';
import cls from './PublicClientProject.module.scss';
import logo from './Logo.svg';
import moment from 'moment';
import { useQuery } from '@apollo/client';
import { QUERY_PUBLIC_CLIENT_PROJECT } from '../../../graphql/client';
import { Avatar, Button, ConfigProvider, theme } from 'antd';
import React from 'react';
import ImageUrl from '../../../helpers/ImageUrl';
import _ from 'lodash';
import {
    to_public_client_project,
} from '../../../routes';
import { LeftOutlined } from '@ant-design/icons';

export function PublicClientProjectTrainings () {
    const { public_key } = useParams();

    const [good, setGood] = React.useState('Хорошо');

    const query = useQuery(QUERY_PUBLIC_CLIENT_PROJECT, {
        variables: {
            public_key: public_key,
            messages_sort: ['createdAt:DESC'],
            messages_pagination: {
                limit: 1,
            },
        },
    });

    if (query.error?.message === 'Not found') {
        return (
            <div className={cls.body}>
                <div className={cls.wrapper}>
                    <div className={cls.block}>
                        <h3>Страница не найдена</h3>
                        <span>Возможно ошибка в ссылке</span>
                        <span>Обратитесь за помощью к администратору</span>
                        <Button size={'large'} onClick={() => setGood('😊️️')}>
                            {good}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    const color = query.data?.publicClientProject?.project?.color || '#2D68C4';

    return (
        <div
            className={cls.body}
            style={{
                backgroundColor: color,
                backgroundImage: `url(${ImageUrl(query.data?.publicClientProject?.project?.cover?.url)})`,
            }}
        >
            <ConfigProvider
                theme={{
                    algorithm: theme.defaultAlgorithm,
                    token: {
                        colorPrimary: color,
                        colorLink: color,
                    },
                }}
            >
                <div className={cls.wrapper}>
                    <div className={cls.header}>
                        {query.data?.publicClientProject?.project?.logo && (
                            <img
                                className={cls.logo}
                                src={ImageUrl(query.data?.publicClientProject?.project?.logo?.url)}
                                alt={query.data?.publicClientProject?.project?.name}
                            />
                        )}
                        <img src={logo} className={cls.logo} alt={'Logo Sila Skilla'} />
                    </div>

                    <Link to={to_public_client_project(public_key)} className={cls.title}>
                        <Button type={'link'} icon={<LeftOutlined />} />
                        <h3>Занятия</h3>
                    </Link>

                    <div className={cls.grid}>
                        {_.map(query.data?.publicClientProject?.trainings, (training) => {
                            return (
                                <div key={training.id} className={cls.block}>
                                    {training.name}
                                    {training.author && (
                                        <div>
                                            <Avatar
                                                size={32}
                                                src={
                                                    training.author.avatar &&
                                                    ImageUrl(training.author.avatar.url)
                                                }
                                                style={!training.author.avatar && { backgroundColor: training.author.color }}
                                            >
                                                {training.author.firstName.charAt(0)}
                                                {training.author.lastName.charAt(0)}
                                            </Avatar>{' '}
                                                {training.author.firstName}{' '}
                                                {training.author.lastName}
                                        </div>
                                    )}
                                    {moment(training.startDate).format('DD MMMM YYYY, HH:mm')}
                                </div>
                            );
                        })}
                    </div>

                    <div className={cls.divider} />

                    <div className={cls.footer}>
                        {_.map(query.data?.publicClientProject?.project?.links, (link, index) => (
                            <a key={`link${index}`} href={link.url} target={'_blank'} rel="noreferrer">
                                {link.name}
                            </a>
                        ))}
                        <span>© {moment().year()}</span>
                    </div>
                </div>
            </ConfigProvider>
        </div>
    );
}
